module.exports = __webpack_public_path__ + "media/icons/cog-28e8658e2ac34dc4fe42701cabab2171.svg";